import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { FormControl, TextField, Typography } from '@mui/material';
import { ThumbDownAltOutlined, ThumbUpAltOutlined } from '@mui/icons-material';
import { submitFeedbackForm } from 'components/views/main/sidebar/Services/FeedbackService';
import { useAppState } from 'components/contexts/State';

export const FeedbackModal = ({
    open,
    onClose,
    title = '',
    onSubmit
}) => {
  let { setIsToasterMessageOpen,
    setToasterType,
    setToasterMessage,
  } = useAppState();
  const userInfo = localStorage.getItem('user');
  const handleSubmit = async () => {

      let user_id = JSON.parse(userInfo).email.toString();
      let other_feedback = document.getElementById('general-feedback').value.toString();

    try {
      if (!other_feedback) {
        setToasterType('error');
        setIsToasterMessageOpen(true);
        setToasterMessage('Please provide feedback before submitting.');
        return;
      }
      await submitFeedbackForm(user_id, '', '', '', other_feedback);
      setToasterType('success');
      setIsToasterMessageOpen(true);
      setToasterMessage('Feedback reminders will appear repeatedly, or use the “Provide Feedback” button in the top right at any time.');
      onClose();
    } catch (error) {
      alert(error.message);
      return;
    }

    // onSubmit(feedbackData);
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        '.MuiDialog-paper': {
          width: '600px',
          boxShadow:
            '0px 8px 10px -5px rgba(0, 0, 0, 0.2),0px 16px 24px 2px rgba(0, 0, 0, 0.14),0px 6px 30px 5px rgba(0, 0, 0, 0.12)',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          borderBottom: '1px solid rgba(0, 37, 71, 0.12)',
        }}
      >
        <div className='text-heading-style-1'>{title}</div>
      </DialogTitle>
      <FormControl  sx={{ padding: '14px 24px 20px 24px !important' }}>
         <Typography variant="body2" sx={{ marginBottom: '20px', alignItems: 'center', gap: '5px' }}>
        Note: For prompt-specific feedback, use the rating tool(
        <ThumbUpAltOutlined sx={{ fontSize: '12px', margin: '0 5px -1px 4px', color: '#002547de' }} />
        <ThumbDownAltOutlined sx={{ fontSize: '12px', margin: '0 5px -1px 4px', color: '#002547de' }} />
        in the chat panel )
      </Typography>
        <div className='normal-text-style-2' style={{ lineHeight: '28px' }}>
          <TextField
            id="general-feedback"
            label="General Feedback"
            multiline
            sx={{
              marginBottom: '16px',
            }}
            autoComplete="off"
            rows={4}
            placeholder="Share any pain points or feedback across the platform"
          />
        </div>
        
      <DialogActions sx={{ padding: '16px 24px' }}>
        <Button onClick={onClose} variant='text' color='primary' size='medium'>
         Cancel
        </Button>
        <Button
          variant='contained'
          className='primary-contained-button-medium'
          onClick={handleSubmit}
        >
          {'Submit'}
        </Button>
      </DialogActions>
      </FormControl>
    </Dialog>
    )
}